import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

// Per-property custom pre-start inspection checklist templates.
export const preStartTemplateService = {
  getList,
  storeOrUpdate,
  destroy,
};

function getList(propertyId) {
  const queryString = qs.stringify({ property_id: propertyId }, { addQueryPrefix: true });
  return axios
    .get(`${apiEndpoint.preStartTemplates}${queryString}`, { headers: authHeader() })
    .then(res => (res && res.status === 200 && res.data.code === '0000' ? res.data : {}));
}

// data is shaped { pre_start_template: { property_id, name, items:[{section, items:[label,...]}] } }.
function storeOrUpdate(data, id = null) {
  return (id
    ? axios.put(apiEndpointFunction.preStartTemplates(id), data, { headers: authHeader() })
    : axios.post(apiEndpoint.preStartTemplates, data, { headers: authHeader() })
  ).then(res => (res && res.status === 200 ? res.data : {}));
}

function destroy(id) {
  return axios
    .delete(apiEndpointFunction.preStartTemplates(id), { headers: authHeader() })
    .then(res => (res && res.status === 200 ? res.data : {}));
}
